import { useRouter } from 'next/compat/router';
import { usePathname } from 'next/navigation';

export default function useIsCalmSleepApp(): boolean {
	const router = useRouter();
	const pathname = usePathname();
	return (router ? router.pathname : pathname)?.startsWith('/calm-sleep-app') ?? false;
}
